import { lazy, Suspense } from 'react'
import { HelpPage, LandingPage, LegalPage, NotFoundPage } from './components/MarketingPages'

const PrivateApplication = lazy(() => import('./PrivateApplication'))

export default function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/'
  if (path === '/') return <LandingPage />
  if (path === '/privacidad') return <LegalPage kind="privacidad" />
  if (path === '/terminos') return <LegalPage kind="terminos" />
  if (path === '/ayuda') return <HelpPage />
  if (path !== '/app') return <NotFoundPage />
  return <Suspense fallback={<div className="app-loading"><div className="loading-logo"><span /><span /><span /></div><p>Cargando TodoBack…</p></div>}><PrivateApplication /></Suspense>
}
